import { FunctionComponent, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { InvoicingAccountOptionResponseContents } from '@cdaas/api-clients/dist/asset-user-openapi';
import { Div, Loader, Page } from '@gaiads/telia-react-component-library';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import OrganizationSetupHeader from '../OrganizationSetupHeader/OrganizationSetupHeader';
import { getUserGroups, getAllUsers, showGrowlNotification } from '../../../store/actions';
import UsersList from './UsersList';
import UsersListHeader from './UsersListHeader';
import { User } from '../../../types';
import { devLogger, getInvoicingAccounts } from '../../../utils';
import { RootState } from '../../../store/reducers';

const Users: FunctionComponent = () => {
  const users: User[] = useSelector((state: RootState) => state.users.users, shallowEqual);
  const isAuthenticated: boolean = useSelector((state: RootState) => state.authentication.authenticated);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation('onboarding');

  const [organizationInvoicingAccounts, setOrganizationInvoicingAccounts] = useState<InvoicingAccountOptionResponseContents[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    async function fetchInvoicingAccounts() {
      if (isAuthenticated) {
        setLoading(true);
        const invoicingAccounts = await getInvoicingAccounts();
        setOrganizationInvoicingAccounts(invoicingAccounts || []);
        setLoading(false);
      }
    }
    fetchInvoicingAccounts();
  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserGroups());
      dispatch(getAllUsers());
    }
  }, [isAuthenticated, dispatch]);

  const validateAndSaveUsers = async (users: unknown) => {
    devLogger('Validating users', users);
    const areUsersValid = (users as User[]).every(user => user.email && user.user_group?.name && !user.modified) && !!(users as User[]).length;

    if (areUsersValid) {
      history.push('/onboarding/groupsettings');
    } else {
      dispatch(showGrowlNotification(t('usersNotOkNotification'), 'error'));
    }
  };

  return (
    <Page>
      <OrganizationSetupHeader onboardingCurrentStepIndex={1} inputData={users} validateAndSaveOnboardingStepData={validateAndSaveUsers} />
      {loading ? (
        <Div alignTextToCenter margin={{ top: 'xlg' }}>
          <Loader />
        </Div>
      ) : (
        <Div margin={{ top: 'lg' }} padding={{ size: 'lg' }} boxShadow={'lg'} backgroundColor="white">
          <UsersListHeader users={users} />
          <UsersList organizationInvoicingAccounts={organizationInvoicingAccounts} />
        </Div>
      )}
    </Page>
  );
};

export default Users;
